<template>
  <CustomDeleteDialog
    dialogTitle="حذف سوال"
    dialogId="delete-question-from-match-confirmation-dialog"
    :isOkDisabled="isOkButtonDisabled"
    @ok="sendDeleteQuestionFromMatchRequest"
  >
    <BCol cols="12">
      <p>
        آیا از حذف سوال
        <bdi style="margin-left: 0.6rem; font-weight: bold">
          {{ selectedQuestionText }}
        </bdi>
        اطمینان دارید؟
      </p>
    </BCol>
  </CustomDeleteDialog>
</template>

<script>
export default {
  emits: ["refetch"],
  props: {
    defaultSelectedQuestion: {
      type: Object,
    },
    selectedMatch: {
      type: Object,
    },
  },
  data() {
    return {
      isLoading: false,
      deleteQuestionPayload: {
        matchId: null,
        questionId: null,
      },
    };
  },
  methods: {
    async sendDeleteQuestionFromMatchRequest() {
      try {
        this.isLoading = true;
        this.deleteQuestionPayload.matchId = this.selectedMatch.id;
        this.deleteQuestionPayload.questionId =
          this.defaultSelectedQuestion.questionId;
        const _this = this;
        let removeQuestionFromMatch = new RemoveQuestionFromMatch(_this);
        removeQuestionFromMatch.setRequestParamDataObj(
          _this.deleteQuestionPayload
        );
        await removeQuestionFromMatch.fetch((res) => {
          if (res.isSuccess) {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف شد!",
                icon: "CheckIcon",
                variant: "success",
                text: "سوال با موفقیت از مسابقه حذف شد.",
              },
            });
            _this.$bvModal.hide(
              "delete-question-from-match-confirmation-dialog"
            );
            _this.$emit("refetch");
          } else {
            _this.$toast({
              component: ToastificationContent,
              props: {
                title: "حذف نشد!",
                icon: "XIcon",
                variant: "danger",
                text: res.errors || "مشکلی پیش آمد، لطفا دوباره امتحان کنید",
              },
            });
          }
        });
      } catch (error) {
        console.error(error);
      } finally {
        this.isLoading = false;
      }
    },
  },
  computed: {
    isOkButtonDisabled() {
      if (
        this.defaultSelectedQuestion &&
        this.defaultSelectedQuestion.questionId &&
        this.selectedMatch &&
        this.selectedMatch.id
      ) {
        return false;
      }
      return true;
    },
    selectedQuestionText() {
      if (
        this.defaultSelectedQuestion &&
        this.defaultSelectedQuestion.questionText
      ) {
        return this.defaultSelectedQuestion.questionText;
      }
      return "";
    },
  },
  components: {
    CustomDeleteDialog,
    IndependentLessonPicker,
    BCol,
    TextInput,
  },
};
import CustomDeleteDialog from "@/views/components/Utils/Dialogs/CustomDeleteDialog.vue";
import IndependentLessonPicker from "@/views/components/Lessons/IndependentLessonPicker.vue";
import TextInput from "@/views/components/Utils/TextInput.vue";
import ToastificationContent from "@core/components/toastification/ToastificationContent";
import { BCol } from "bootstrap-vue";
import { RemoveQuestionFromMatch } from "@/libs/Api/Matches";
</script>
